import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Cpu, Cloud, Shield, Activity } from "lucide-react";
import "bootstrap/dist/css/bootstrap.min.css";
import AOS from "aos";
import "aos/dist/aos.css";
import DevOne from "../../assets/image/devops/dev-1.png";
import DevTwo from "../../assets/image/devops/dev-2.jpg";
import img2 from "../../assets/image/devops/dev-3.jpg";
// import img1 from "../../assets/image/devops/DevOpsServices.png";
import drone from "../../assets/image/Drone/drone.jpg";
import drone_architecture from "../../assets/image/Drone/drone_architecture.png";
import Drone1 from "../../assets/image/Drone/Drone1.jpg";
import Drone2 from "../../assets/image/Drone/Drone2.jpg";
import Drone3 from "../../assets/image/Drone/Drone3.jpg";
import Drone4 from "../../assets/image/Drone/Drone4.jpg";
import Drone5 from "../../assets/image/Drone/Drone5.jpg";
// import img4 from "../../assets/image/devops/49452.jpg";
// import img5 from "../../assets/image/devops/20945220.jpg";
import img6 from "../../assets/image/devops/122304-OQ3NDB-531.jpg";
import img7 from "../../assets/image/devops/2903.jpg";
import img8 from "../../assets/image/devops/standard-quality-control-collage-concept.jpg";
import Footer from "../Footer/Footer";
import "../../assets/css/devops.css";
import { Carousel } from "react-bootstrap";
import banner1 from "../../assets/image/Drone/banner1.png";
import banner2 from "../../assets/image/Drone/banner2.png";
import banner3 from "../../assets/image/Drone/banner3.png";
import banner4 from "../../assets/image/Drone/banner4.png";
import banner5 from "../../assets/image/Drone/banner5.png";

import {
  FaEnvelope,
  FaSkype,
  FaPhone,
  FaUser,
  FaGlobe,
  FaDollarSign,
  FaChartLine,
  FaPen,
  FaPaperPlane,
  FaBuilding,
  FaTimes,
} from "react-icons/fa";
import { MdOutlineMiscellaneousServices } from "react-icons/md";
import { IoLogoWhatsapp, IoMdBuild } from "react-icons/io";
import emailjs from "@emailjs/browser";
import { useRef } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import data from "../../Meta/Meta_ApiUrl";
const droneSliderImages = [banner1, banner2, banner3, banner4, banner5];

const DroneAndEducation = () => {
  const [meta, setMeta] = useState({});

  useEffect(() => {
    const devops = data[0]?.services_page_Devops;

    if (devops) {
      setMeta(devops);
    }
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to top-left corner
  }, []);

  const [isOpenEnquiry, setIsOpenEnquiry] = useState(false);
  const [formDataEnquiry, setFormDataEnquiry] = useState({
    name: "",
    email: "",
    phone: "",
    whatsapp: "",
    companyName: "",
    companyService: "",
    serviceType: "",
    country: "",
    message: "",
  });

  const form = useRef();

  const handleClose = () => {
    setIsOpenEnquiry(false);
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormDataEnquiry((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmitForm = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_z73r4mc",
        "template_evcmg1l",
        form.current,
        "EscxBRJBS9wDUay2E"
      )
      .then(
        (result) => {
          alert("Enquiry sent successfully!");
          setIsOpenEnquiry(false);
          setFormDataEnquiry({
            name: "",
            email: "",
            phone: "",
            whatsapp: "",
            companyName: "",
            companyService: "",
            serviceType: "",
            country: "",
            message: "",
          });
        },
        (error) => {
          console.error("Failed to send email:", error.text);
          alert("Failed to send enquiry. Please try again.");
        }
      );
  };

  const devOpsSolutions = [
    {
      id: 1,
      title: "Inspection Services",
      description: "Advanced drone inspections for critical infrastructure.",
      icon: "🔍",
      features: [
        "Solar Panel Inspection",
        "Wind Turbine Inspection",
        "Power Line Inspection",
        "Telecom Tower Inspection",
        "Industrial Inspection",
      ],
      image: Drone1,
    },
    {
      id: 2,
      title: "Survey & Mapping",
      description: "High-precision mapping and geospatial data collection.",
      icon: "🗺️",
      features: [
        "Land Surveying",
        "Topographic Mapping",
        "GIS Data Collection",
        "Construction Mapping",
        "Volume Calculation",
      ],
      image: Drone2,
    },
    {
      id: 3,
      title: "Aerial Cinematography",
      description: "Capture stunning visuals from the sky.",
      icon: "🎥",
      features: [
        "Real Estate Shoots",
        "Promotional Videos",
        "Wedding Coverage",
        "Corporate Events",
        "Aerial Photography",
      ],
      image: Drone3,
    },
    {
      id: 4,
      title: "Agriculture Services",
      description: "Smart farming with precision drone technology.",
      icon: "🌾",
      features: [
        "Crop Monitoring",
        "Drone Spraying",
        "Field Mapping",
        "Precision Agriculture",
      ],
      image: Drone4,
    },
    {
      id: 5,
      title: "Special Activities",
      description: "Creative drone-based services for unique needs.",
      icon: "🎯",
      features: [
        "Banner Drop",
        "Flower Drop",
        "Gift Delivery",
        "LED Banner Ads",
      ],
      image: Drone5,
    },
  ];

  const [hoveredCard, setHoveredCard] = React.useState(null);

  const features = [
    {
      icon: <Cpu size={40} />,
      title: "Inspection Excellence",
      description:
        "Perform safe, fast, and accurate inspections for energy, telecom, and industrial sectors.",
    },
    {
      icon: <Cloud size={40} />,
      title: "Survey Precision",
      description:
        "Deliver highly accurate mapping and geospatial data for construction and land analysis.",
    },
    {
      icon: <Activity size={40} />,
      title: "Real-Time Monitoring",
      description:
        "Track assets and monitor environments with real-time aerial insights.",
    },
    {
      icon: <Shield size={40} />,
      title: "Safe & Reliable",
      description:
        "Minimize human risk with automated drone-based operations and inspections.",
    },
  ];

  const techCategories = [
    {
      title: "Drone Training",
      icon: "🚁",
      tools: ["Basic to Advanced", "Flight Training", "DGCA Awareness"],
      description: "Hands-on drone training programs.",
    },
    {
      title: "Robotics",
      icon: "🤖",
      tools: ["Automation", "Embedded Systems"],
      description: "Learn robotics with real-world applications.",
    },
    {
      title: "IoT",
      icon: "🌐",
      tools: ["Sensors", "Smart Devices"],
      description: "Build connected smart systems.",
    },
    {
      title: "AI & Automation",
      icon: "🧠",
      tools: ["Machine Learning", "Automation"],
      description: "Future-ready AI and automation skills.",
    },
  ];

  // Initialize AOS
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: true,
      mirror: false,
    });
  }, []);

  const inputStyle = {
    width: "100%",
    padding: "8px 10px",
    border: "2px solid #e9ecef",
    borderRadius: "10px",
    fontSize: "0.95rem",
    background: "white",
    outline: "none",
    transition: "all 0.3s ease",
  };

  return (
    <HelmetProvider>
      <div className="overflow-hidden">
        <Helmet>
          <title>{meta?.title || "Services-Devops  - SHIV NXTGEN TECHNOLOGIES PRIVATE LIMITED"}</title>
          <meta
            name="description"
            content={meta?.meta?.meta1?.content || "Our curriculum."}
          />
        </Helmet>

        {/* Enquiry Form */}
        {isOpenEnquiry && (
          <div
            onClick={handleBackdropClick}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0, 0, 0, 0.6)",
              backdropFilter: "blur(8px)",
              zIndex: 1050,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                position: "relative",
                width: "100%",
                maxWidth: "650px",
                maxHeight: "100vh",
                background: "#fff",
                borderRadius: "20px",
                overflow: "hidden",
                boxShadow: "0 15px 50px rgba(0,0,0,0.25)",
              }}
            >
              {/* Fixed Header */}
              <div
                style={{
                  position: "sticky",
                  top: 0,
                  background: "#00b7eb",
                  color: "#ffffff",
                  padding: "15px 20px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  zIndex: 2,
                }}
              >
                <h3
                  style={{
                    margin: 0,
                    fontSize: "1.5rem",
                    fontWeight: "700",
                    textAlign: "center",
                  }}
                >
                  Enquiry Form
                </h3>
                <button
                  onClick={handleClose}
                  style={{
                    background: "transparent",
                    border: "none",
                    color: "#ffffff",
                    fontSize: "20px",
                    cursor: "pointer",
                  }}
                >
                  <FaTimes />
                </button>
              </div>

              {/* Scrollable Form */}
              <div
                style={{
                  padding: "20px",
                  overflowY: "auto",
                  maxHeight: "calc(100vh - 70px)", // Adjust based on header height
                }}
              >
                <form ref={form} onSubmit={handleSubmitForm}>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns:
                        "repeat(auto-fit, minmax(250px, 1fr))",
                      gap: "20px",
                      marginBottom: "20px",
                    }}
                  >
                    {/* Full Name */}
                    <div>
                      <FaUser
                        style={{
                          color: "#00b7eb",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Full Name *</label>
                      <input
                        type="text"
                        name="name"
                        value={formDataEnquiry.name}
                        onChange={handleInputChange}
                        required
                        placeholder="Enter full name"
                        style={inputStyle}
                      />
                    </div>

                    {/* Email */}
                    <div>
                      <FaEnvelope
                        style={{
                          color: "#00b7eb",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Email Address *</label>
                      <input
                        type="email"
                        name="email"
                        value={formDataEnquiry.email}
                        onChange={handleInputChange}
                        required
                        placeholder="Enter email"
                        style={inputStyle}
                      />
                    </div>

                    {/* Phone */}
                    <div>
                      <FaPhone
                        style={{
                          color: "#00b7eb",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Phone Number</label>
                      <input
                        type="tel"
                        name="phone"
                        value={formDataEnquiry.phone}
                        onChange={handleInputChange}
                        placeholder="Enter phone"
                        style={inputStyle}
                      />
                    </div>

                    {/* WhatsApp */}
                    <div>
                      <IoLogoWhatsapp
                        style={{
                          color: "#00b7eb",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">WhatsApp</label>
                      <input
                        type="tel"
                        name="whatsapp"
                        value={formDataEnquiry.whatsapp}
                        onChange={handleInputChange}
                        placeholder="Enter WhatsApp"
                        style={inputStyle}
                      />
                    </div>

                    {/* Company Name */}
                    <div>
                      <FaBuilding
                        style={{
                          color: "#00b7eb",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Company Name</label>
                      <input
                        type="text"
                        name="companyName"
                        value={formDataEnquiry.companyName}
                        onChange={handleInputChange}
                        placeholder="Enter company name"
                        style={inputStyle}
                      />
                    </div>

                    {/* Company Service */}
                    <div>
                      <IoMdBuild
                        style={{
                          color: "#00b7eb",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Company Service</label>
                      <select
                        name="companyService"
                        value={formDataEnquiry.companyService}
                        onChange={handleInputChange}
                        style={inputStyle}
                      >
                        <option value="" disabled>
                          Select
                        </option>
                        <option value="Solo">Solo</option>
                        <option value="Pvt">Pvt</option>
                        <option value="LLP">LLP</option>
                        <option value="Startup">Startup</option>
                        <option value="Partnership">Partnership</option>
                      </select>
                    </div>

                    {/* Service Type */}
                    <div>
                      <MdOutlineMiscellaneousServices
                        style={{
                          color: "#00b7eb",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Type of Service</label>
                      <select
                        name="serviceType"
                        value={formDataEnquiry.serviceType}
                        onChange={handleInputChange}
                        style={inputStyle}
                      >
                        <option value="" disabled>
                          Select
                        </option>
                        <option value="Drone">Drone Solutions</option>
                        <option value="Robotics">Robotics Solutions</option>
                        <option value="IOT">Iot Solutions</option>
                        <option value="AI">Artificial Intelligence</option>
                        <option value="Software">Software Development</option>
                        <option value="App">App Development</option>
                        {/* <option value="Game">Game Development</option> */}
                        <option value="Website">Website Development</option>
                        <option value="AR & VR Development">
                          AR & VR Apps
                        </option>
                        {/* <option value="Casino Api">Casino API</option> */}
                        {/* <option value="Devops Solutions">DevOps</option> */}
                        {/* <option value="It Support">IT Support</option> */}
                        <option value="Training Programs">Training</option>
                        {/* <option value="Digital Marketing">
                          Digital Marketing
                        </option> */}
                      </select>
                    </div>

                    {/* Country */}
                    <div>
                      <FaGlobe
                        style={{
                          color: "#00b7eb",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Country</label>
                      <input
                        type="text"
                        name="country"
                        value={formDataEnquiry.country}
                        onChange={handleInputChange}
                        placeholder="Enter country"
                        style={inputStyle}
                      />
                    </div>
                  </div>

                  {/* Message */}
                  <div>
                    <label className="fw-bold">Your Message *</label>
                    <textarea
                      name="message"
                      value={formDataEnquiry.message}
                      onChange={handleInputChange}
                      required
                      rows={1}
                      placeholder="Tell us about your requirements..."
                      style={{
                        ...inputStyle,
                        resize: "vertical",
                      }}
                    />
                  </div>

                  {/* Submit Button */}
                  <div
                    className="mt-1 margin-top-home"
                    style={{ textAlign: "center" }}
                  >
                    <button
                      type="submit"
                      style={{
                        background: "#00b7eb",
                        color: "white",
                        padding: "10px 20px",
                        borderRadius: "25px",
                        fontWeight: "600",
                        border: "none",
                        cursor: "pointer",
                      }}
                    >
                      <FaPaperPlane style={{ marginRight: "8px" }} />
                      Send Message
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}

        {/* Hero Section */}
        <div
          className="position-relative min-vh-50 d-flex align-items-center justify-content-center bg-dark text-white"
          style={{
            backgroundImage: `url(${drone})`,
            backgroundSize: "cover",
            backgroundPosition: "50% 50%",
            backgroundRepeat: "no-repeat",
          }}
          data-aos="fade-up"
          data-aos-delay="100"
        >
          <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark opacity-50"></div>
          <div className="container position-relative z-1">
            <div className="row align-items-center">
              <div className="col-lg-8 col-md-10 col-sm-12">
                <nav
                  aria-label="breadcrumb"
                  className="mb-4"
                  data-aos="fade-right"
                  data-aos-delay="200"
                >
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a
                        href="/"
                        className="text-white fw-bold text-decoration-none"
                      >
                        Home
                      </a>
                    </li>
                    <li
                      className="text-white fw-bold breadcrumb-item active"
                      aria-current="page"
                    >
                      Drone & Education
                    </li>
                  </ol>
                </nav>
                <h1
                  className="display-4 fw-bold mb-3"
                  data-aos="fade-up"
                  data-aos-delay="300"
                >
                  Drone & Education
                </h1>
              </div>
            </div>
          </div>
        </div>

        {/* Main Content Section */}
        <div className="container-fluid py-5 bg-light">
          <div className="container">
            <div className="row align-items-center g-4">
              <div className="col-lg-6 col-md-12">
                <div className="pe-lg-4">
                  <h2 className="display-5 fw-bold mb-4">
                    Aerial Intelligence
                    <span className="mx-3 font-red">Precision & Performance</span>
                  </h2>

                  <p className="mb-4 font-para">
                    At Shiv Research Technologies Private Limited, we deliver advanced drone solutions that transform how industries capture data, monitor assets, and make smarter decisions.
                  </p>

                  <p className="mb-4 font-para">
                    From high-precision surveys to cinematic visuals and industrial inspections — we bring intelligence from the sky to your business.
                  </p>
                  <ul className="list-unstyled">
                    <li className="mb-3 d-flex align-items-start">
                      <i className="bi bi-check-circle-fill font-red me-3 mt-1"></i>
                      <div>
                        <strong>Improve efficiency</strong> <span className="text-dark">with fast and accurate aerial data</span>
                      </div>
                    </li>

                    <li className="mb-3 d-flex align-items-start">
                      <i className="bi bi-check-circle-fill font-red me-3 mt-1"></i>
                      <div>
                        <strong>Reduce operational risks</strong> <span className="text-dark">through remote inspections</span>
                      </div>
                    </li>

                    <li className="mb-3 d-flex align-items-start">
                      <i className="bi bi-check-circle-fill font-red me-3 mt-1"></i>
                      <div>
                        <strong>Enhance decision making</strong> <span className="text-dark">with real-time insights</span>
                      </div>
                    </li>

                    <li className="mb-3 d-flex align-items-start">
                      <i className="bi bi-check-circle-fill font-red me-3 mt-1"></i>
                      <div>
                        <strong>Deliver precision results</strong> <span className="text-dark">with advanced drone technology</span>
                      </div>
                    </li>
                  </ul>
                  <div className="mt-4">
                    <button
                      className="btn btn-danger text-white fw-semibold px-4 py-2"
                      onClick={() => setIsOpenEnquiry(true)}
                    >
                      Get Started
                    </button>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 col-md-12 d-lg-block">
                <div className="text-center">
                  <div
                    className="bg-gradient p-4 rounded-4 d-flex align-items-center justify-content-center"
                  >
                    <img
                      src={drone_architecture}
                      alt="DevOps Integration"
                      className="img-fluid rounded-3"
                      style={{ maxWidth: "100%", height: "auto" }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* DevOps Solutions Section */}
        <section>
          <div className="container py-5">
            <h3
              className="display-5 text-center fw-bold mb-3"
              data-aos="fade-up"
            >
              Drone Services
              <span className="font-red"> Solutions</span>
            </h3>
            <p
              className="font-para text-dark text-center mb-4"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              Our Drone Division provides end-to-end aerial solutions designed to improve efficiency, reduce risks, and deliver highly accurate data across industries.
            </p>

            {devOpsSolutions.length > 0 && (
              <>
                {/* Desktop View - First row (3 cards) */}
                <div className="row g-2 d-none d-lg-flex">
                  {devOpsSolutions.slice(0, 3).map((service, index) => (
                    <div
                      key={service.id}
                      className="col-lg-4 mb-4 d-flex justify-content-center"
                      data-aos="fade-up"
                      data-aos-delay={index * 100}
                    >
                      <div
                        className="card h-100 border-0 shadow position-relative overflow-hidden"
                        style={{
                          width: "100%",
                          maxWidth: "350px",
                          transform:
                            hoveredCard === index
                              ? "translateY(-10px)"
                              : "translateY(0)",
                          transition: "all 0.3s ease",
                          cursor: "pointer",
                        }}
                        onMouseEnter={() => setHoveredCard(index)}
                        onMouseLeave={() => setHoveredCard(null)}
                      >
                        {/* Card content remains the same */}
                        <img
                          src={service.image}
                          className="card-img-top"
                          alt={service.title}
                          style={{ height: "200px", objectFit: "cover" }}
                        />
                        <div
                          className="position-absolute top-0 start-0 w-100 h-100 opacity-10"
                          style={{ background: service.gradient }}
                        ></div>
                        <div className="card-body p-3 position-relative">
                          <div className="d-flex align-items-center mb-3">
                            <div className="rounded-circle d-flex align-items-center justify-content-center me-3 bg-light p-2">
                              <span className="fs-3">{service.icon}</span>
                            </div>
                            <h5 className=" font-card-heading fw-bold mb-0 font-red">
                              {service.title}
                            </h5>
                          </div>
                          <p className="font-card-para fw-medium mb-2">
                            {service.description}
                          </p>
                          <div className="mb-4">
                            {service.features.map((feature, idx) => (
                              <div
                                key={idx}
                                className="d-flex align-items-center mb-2"
                              >
                                <span className="text-dark me-2">✓</span>
                                <small className="font-card-feature text-dark fw-medium fs-6">
                                  {feature}
                                </small>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Desktop View - Second row (2 centered cards) */}
                {devOpsSolutions.length > 3 && (
                  <div className="row g-2 d-none d-lg-flex">
                    <div className="col-lg-2"></div>
                    {devOpsSolutions.slice(3, 5).map((service, index) => (
                      <div
                        key={service.id}
                        className="col-lg-4 mb-4 d-flex justify-content-center"
                        data-aos="fade-up"
                        data-aos-delay={(index + 3) * 100}
                      >
                        <div
                          className="card h-100 border-0 shadow-lg position-relative overflow-hidden"
                          style={{
                            width: "100%",
                            maxWidth: "350px",
                            transform:
                              hoveredCard === index + 3
                                ? "translateY(-10px)"
                                : "translateY(0)",
                            transition: "all 0.3s ease",
                            cursor: "pointer",
                          }}
                          onMouseEnter={() => setHoveredCard(index + 3)}
                          onMouseLeave={() => setHoveredCard(null)}
                        >
                          {/* Card content remains the same */}
                          <img
                            src={service.image}
                            className="card-img-top"
                            alt={service.title}
                            style={{ height: "150px", objectFit: "cover" }}
                          />
                          <div
                            className="position-absolute top-0 start-0 w-100 h-100 opacity-10"
                            style={{ background: service.gradient }}
                          ></div>
                          <div className="card-body p-3 position-relative">
                            <div className="d-flex align-items-center mb-3">
                              <div className="rounded-circle d-flex align-items-center justify-content-center me-3 bg-light p-2">
                                <span className="fs-3">{service.icon}</span>
                              </div>
                              <h5 className=" font-card-heading fw-bold mb-0 font-red">
                                {service.title}
                              </h5>
                            </div>
                            <p className="font-card-para fw-medium mb-2">
                              {service.description}
                            </p>
                            <div className="mb-4">
                              {service.features.map((feature, idx) => (
                                <div
                                  key={idx}
                                  className="d-flex align-items-center mb-2"
                                >
                                  <span className="text-dark me-2">✓</span>
                                  <small className="font-card-feature text-dark fw-medium fs-6">
                                    {feature}
                                  </small>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                    <div className="col-lg-2"></div>
                  </div>
                )}

                {/* Tablet View - First row (2 cards) */}
                <div className="row g-2 d-lg-none d-md-flex d-none">
                  {devOpsSolutions.slice(0, 2).map((service, index) => (
                    <div
                      key={service.id}
                      className="col-md-6 mb-4 d-flex justify-content-center"
                      data-aos="fade-up"
                      data-aos-delay={index * 100}
                    >
                      <div
                        className="card h-100 border-0 shadow-lg position-relative overflow-hidden"
                        style={{
                          width: "100%",
                          maxWidth: "350px",
                          transform:
                            hoveredCard === index
                              ? "translateY(-10px)"
                              : "translateY(0)",
                          transition: "all 0.3s ease",
                          cursor: "pointer",
                        }}
                        onMouseEnter={() => setHoveredCard(index)}
                        onMouseLeave={() => setHoveredCard(null)}
                      >
                        {/* Card content remains the same */}
                        <img
                          src={service.image}
                          className="card-img-top"
                          alt={service.title}
                          style={{ height: "150px", objectFit: "cover" }}
                        />
                        <div
                          className="position-absolute top-0 start-0 w-100 h-100 opacity-10"
                          style={{ background: service.gradient }}
                        ></div>
                        <div className="card-body p-3 position-relative">
                          <div className="d-flex align-items-center mb-3">
                            <div className="rounded-circle d-flex align-items-center justify-content-center me-3 bg-light p-2">
                              <span className="fs-3">{service.icon}</span>
                            </div>
                            <h5 className=" font-card-heading fw-bold mb-0 font-red">
                              {service.title}
                            </h5>
                          </div>
                          <p className="font-card-para fw-medium mb-2">
                            {service.description}
                          </p>
                          <div className="mb-4">
                            {service.features.map((feature, idx) => (
                              <div
                                key={idx}
                                className="d-flex align-items-center mb-2"
                              >
                                <span className="text-dark me-2">✓</span>
                                <small className="font-card-feature text-dark fw-medium fs-6">
                                  {feature}
                                </small>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Tablet View - Second row (2 cards) */}
                {devOpsSolutions.length > 2 && (
                  <div className="row g-2 d-lg-none d-md-flex d-none">
                    {devOpsSolutions.slice(2, 4).map((service, index) => (
                      <div
                        key={service.id}
                        className="col-md-6 mb-4 d-flex justify-content-center"
                        data-aos="fade-up"
                        data-aos-delay={(index + 2) * 100}
                      >
                        <div
                          className="card h-100 border-0 shadow-lg position-relative overflow-hidden"
                          style={{
                            width: "100%",
                            maxWidth: "350px",
                            transform:
                              hoveredCard === index + 2
                                ? "translateY(-10px)"
                                : "translateY(0)",
                            transition: "all 0.3s ease",
                            cursor: "pointer",
                          }}
                          onMouseEnter={() => setHoveredCard(index + 2)}
                          onMouseLeave={() => setHoveredCard(null)}
                        >
                          {/* Card content remains the same */}
                          <img
                            src={service.image}
                            className="card-img-top"
                            alt={service.title}
                            style={{ height: "150px", objectFit: "cover" }}
                          />
                          <div
                            className="position-absolute top-0 start-0 w-100 h-100 opacity-10"
                            style={{ background: service.gradient }}
                          ></div>
                          <div className="card-body p-3 position-relative">
                            <div className="d-flex align-items-center mb-3">
                              <div className="rounded-circle d-flex align-items-center justify-content-center me-3 bg-light p-2">
                                <span className="fs-3">{service.icon}</span>
                              </div>
                              <h5 className=" font-card-heading fw-bold mb-0 font-red">
                                {service.title}
                              </h5>
                            </div>
                            <p className="font-card-para fw-medium mb-2">
                              {service.description}
                            </p>
                            <div className="mb-4">
                              {service.features.map((feature, idx) => (
                                <div
                                  key={idx}
                                  className="d-flex align-items-center mb-2"
                                >
                                  <span className="text-dark me-2">✓</span>
                                  <small className="font-card-feature text-dark fw-medium fs-6">
                                    {feature}
                                  </small>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}

                {/* Tablet View - Third row (1 centered card) */}
                {devOpsSolutions.length > 4 && (
                  <div className="row g-2 d-lg-none d-md-flex d-none">
                    <div className="col-md-3"></div>
                    <div
                      key={devOpsSolutions[4].id}
                      className="col-md-6 mb-4 d-flex justify-content-center"
                      data-aos="fade-up"
                      data-aos-delay={400}
                    >
                      <div
                        className="card h-100 border-0 shadow-lg position-relative overflow-hidden"
                        style={{
                          width: "100%",
                          maxWidth: "350px",
                          transform:
                            hoveredCard === 4
                              ? "translateY(-10px)"
                              : "translateY(0)",
                          transition: "all 0.3s ease",
                          cursor: "pointer",
                        }}
                        onMouseEnter={() => setHoveredCard(4)}
                        onMouseLeave={() => setHoveredCard(null)}
                      >
                        {/* Card content remains the same */}
                        <img
                          src={devOpsSolutions[4].image}
                          className="card-img-top"
                          alt={devOpsSolutions[4].title}
                          style={{ height: "150px", objectFit: "cover" }}
                        />
                        <div
                          className="position-absolute top-0 start-0 w-100 h-100 opacity-10"
                          style={{ background: devOpsSolutions[4].gradient }}
                        ></div>
                        <div className="card-body p-3 position-relative">
                          <div className="d-flex align-items-center mb-3">
                            <div className="rounded-circle d-flex align-items-center justify-content-center me-3 bg-light p-2">
                              <span className="fs-3">
                                {devOpsSolutions[4].icon}
                              </span>
                            </div>
                            <h5 className=" font-card-heading fw-bold mb-0 font-red">
                              {devOpsSolutions[4].title}
                            </h5>
                          </div>
                          <p className="font-card-para fw-medium mb-2">
                            {devOpsSolutions[4].description}
                          </p>
                          <div className="mb-4">
                            {devOpsSolutions[4].features.map((feature, idx) => (
                              <div
                                key={idx}
                                className="d-flex align-items-center mb-2"
                              >
                                <span className="text-dark me-2">✓</span>
                                <small className="font-card-feature text-dark fw-medium fs-6">
                                  {feature}
                                </small>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3"></div>
                  </div>
                )}

                {/* Mobile View (1 card per row) */}
                <div className="row g-2 d-md-none">
                  {devOpsSolutions.map((service, index) => (
                    <div
                      key={service.id}
                      className="col-12 mb-4 d-flex justify-content-center"
                      data-aos="fade-up"
                      data-aos-delay={index * 100}
                    >
                      <div
                        className="card h-100 border-0 shadow-lg position-relative overflow-hidden"
                        style={{
                          // width: "100%",
                          // maxWidth: "350px",
                          transform:
                            hoveredCard === index
                              ? "translateY(-10px)"
                              : "translateY(0)",
                          transition: "all 0.3s ease",
                          cursor: "pointer",
                        }}
                        onMouseEnter={() => setHoveredCard(index)}
                        onMouseLeave={() => setHoveredCard(null)}
                      >
                        {/* Card content remains the same */}
                        <img
                          src={service.image}
                          className="card-img-top"
                          alt={service.title}
                          style={{ height: "150px", objectFit: "cover" }}
                        />
                        <div
                          className="position-absolute top-0 start-0  h-100 opacity-10"
                          style={{ background: service.gradient }}
                        ></div>
                        <div className="card-body  position-relative">
                          <div className="d-flex align-items-center mb-3">
                            <div className="rounded-circle d-flex align-items-center justify-content-center me-3 bg-light p-2">
                              <span className="fs-3">{service.icon}</span>
                            </div>
                            <h5 className=" font-card-heading fw-bold mb-0 font-red">
                              {service.title}
                            </h5>
                          </div>
                          <p className="font-card-para fw-medium mb-2">
                            {service.description}
                          </p>
                          <div className="mb-4">
                            {service.features.map((feature, idx) => (
                              <div
                                key={idx}
                                className="d-flex align-items-center mb-2"
                              >
                                <span className="text-dark me-2">✓</span>
                                <small className="font-card-feature text-dark fw-medium fs-6">
                                  {feature}
                                </small>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
        </section>

        {/* Features Section */}
        <section className="py-5 bg-light">
          <Container>
            <Row className="align-items-center">
              <Col lg={4} className="d-none d-lg-block" data-aos="fade-right">
                <div className="text-center">
                  <img
                    src={img2}
                    alt="DevOps Illustration"
                    className="img-fluid rounded-3 shadow-lg"
                    style={{ maxWidth: "100%", height: "auto" }}
                  />
                </div>
              </Col>
              <Col lg={8} data-aos="fade-left">
                <div className="ps-lg-4">
                  <h2 className="display-5 fw-bold mb-4 text-center text-lg-start">
                    Our Drone <span className="font-red">Capabilities</span>
                  </h2>
                  <Row className="g-4">
                    {features.map((feature, index) => (
                      <Col
                        xs={12}
                        key={index}
                        data-aos="fade-up"
                        data-aos-delay={index * 150}
                      >
                        <div className="p-4 h-100 bg-white rounded-3 shadow-sm border">
                          <Row className="align-items-center">
                            <Col xs="auto">
                              <div
                                className="d-flex align-items-center justify-content-center rounded-3 bg-light"
                                style={{
                                  width: "70px",
                                  height: "70px",
                                  color: "#dc3545",
                                }}
                              >
                                {feature.icon}
                              </div>
                            </Col>
                            <Col>
                              <h4 className="fw-bold font-red mb-2">
                                {feature.title}
                              </h4>
                              <p className="mb-0">{feature.description}</p>
                            </Col>
                          </Row>
                        </div>
                      </Col>
                    ))}
                  </Row>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        {/* Technology & Tools Section */}
        <section className="py-5">
          <div className="container">
            <h2
              className="display-5 fw-bold text-center mb-3"
              data-aos="fade-up"
            >
              Education & <span className="font-red">Training</span>
            </h2>
            <p
              className="text-center font-para mb-5"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              Cutting-edge tech stack for robust and scalable solutions
            </p>

            <div className="row g-4">
              {techCategories.map((category, index) => (
                <div
                  key={index}
                  className="col-lg-3 col-md-6 col-sm-12"
                  data-aos="zoom-in"
                  data-aos-delay={index * 150}
                >
                  <div className="card h-100 border-0 shadow-sm bg-dark text-white">
                    <div className="card-body p-4">
                      <div className="d-flex align-items-center mb-3">
                        <span className="fs-2 me-3">{category.icon}</span>
                        <h5 className="font-red fw-bold mb-0">
                          {category.title}
                        </h5>
                      </div>
                      <p className="text-white mb-3">{category.description}</p>
                      <div className="d-flex flex-wrap gap-2">
                        {category.tools.map((tool, idx) => (
                          <span key={idx} className="badge bg-secondary">
                            {tool}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* <div className="container py-5">
          <h3 className="text-center fw-bold mb-4">
            Drone <span className="font-red">Banners</span>
          </h3>

          <div className="row justify-content-center bg">
            <div className="col-lg-8 col-md-10 ">

              <Carousel
                fade
                indicators={true}
                controls={true}
                interval={3000}
                pause="hover"
                width={200}
              >
                {droneSliderImages.map((img, index) => (
                  <Carousel.Item key={index}>
                    <div className="position-relative">

                      <img
                        src={img}
                        alt={`Drone ${index}`}
                        className="d-block w-50 rounded-4"
                        style={{
                          height: "400px",
                          objectFit: "contain",
                        }}
                      />

                      <div
                        className="position-absolute top-0 start-0 w-100 h-100 rounded-4"
                        style={{
                          background:
                            "linear-gradient(135deg, rgba(26,0,51,0.4), rgba(114,9,183,0.4))",
                        }}
                      ></div>

                    </div>
                  </Carousel.Item>
                ))}
              </Carousel>

            </div>
          </div>
        </div> */}



        {/* CTA Section */}
        <section
          className="py-5 text-white text-center"
          style={{
            background: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url(${img8})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundAttachment: "fixed",
          }}
        >
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-8 col-md-10">
                <h2 className="display-5 fw-bold mb-3" data-aos="fade-up">
                  Learn Today. Build Tomorrow. Lead the Future.
                </h2>
                <p
                  className="lead mb-4"
                  data-aos="fade-up"
                  data-aos-delay="200"
                >
                  Shiv Research Technologies provides industry-focused training in Drone Technology, AI, IoT, and Robotics — making students job-ready and future-ready.
                </p>
                <div data-aos="fade-up" data-aos-delay="400">
                  <button
                    className="btn btn-danger btn-lg px-4 py-2"
                    onClick={() => setIsOpenEnquiry(true)}
                  >
                    Contact Us
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Footer />

        {/* Custom Styles */}
        <style>{`
          .min-vh-50 {
            min-height: 50vh;
          }

          .z-1 {
            z-index: 1;
          }

          .overflow-hidden {
            overflow-x: hidden;
          }

          @media (max-width: 768px) {
            .display-4 {
              font-size: 2rem !important;
            }

            .display-5 {
              font-size: 1.75rem !important;
            }

            .card-img-top {
              height: 150px !important;
            }

            .min-vh-50 {
              min-height: 40vh;
            }
          }

          @media (max-width: 576px) {
            .display-4 {
              font-size: 1.5rem !important;
            }

            .display-5 {
              font-size: 1.25rem !important;
            }

            .p-4 {
              padding: 1rem !important;
            }

            .py-5 {
              padding-top: 2rem !important;
              padding-bottom: 2rem !important;
            }
          }
        `}</style>
      </div>
    </HelmetProvider>
  );
};

export default DroneAndEducation;
